module.exports = __webpack_public_path__ + "img/oostenrijk2.e18c8da7.jpg";